import { cn } from '@/lib/utils';

type StatusValue = 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'REVIEWED' | 'NOT_REVIEWED';

interface StatusBadgeProps {
  status: StatusValue;
  className?: string;
}

const STATUS_CONFIG: Record<StatusValue, { label: string; className: string }> = {
  IN_PROGRESS: {
    label: 'In Progress',
    className:
      'bg-amber-500/10 text-amber-600 border border-amber-500/20',
  },
  COMPLETED: {
    label: 'Completed',
    className:
      'bg-emerald-500/10 text-emerald-600 border border-emerald-500/20',
  },
  FAILED: {
    label: 'Failed',
    className: 'bg-red-500/10 text-red-500 border border-red-500/20',
  },
  NOT_REVIEWED: {
    label: 'Not Reviewed',
    className: 'bg-gray-500/10 text-gray-500 border border-gray-500/20',
  },
  REVIEWED: {
    label: 'Reviewed',
    className:
      'bg-emerald-500/5 text-emerald-500 border border-emerald-500/10',
  },
};

export default function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
}
